import React from 'react';
import { TextField } from '@mui/material';
import { EventType } from '../../services/Types';
import { isPodcastEnabled } from '../../config/featureFlags';

interface SelectEventTypeProps {
  value: string;
  onChange: (eventType: string) => void;
  disabled?: boolean;
  label?: string;
  excludedEventTypes?: EventType[];
}

export function SelectEventType({ value, onChange, disabled = false, label = "Event Type", excludedEventTypes = [] }: SelectEventTypeProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  const availableEventTypes = Object.values(EventType).filter(
    eventType => !excludedEventTypes.includes(eventType)
  ).filter(
    eventType => isPodcastEnabled || eventType !== EventType.PODCAST
  );

  return (
    <TextField
      select
      label={label}
      value={value}
      onChange={handleChange}
      disabled={disabled}
      SelectProps={{
        native: true,
      }}
      fullWidth
    >
      {availableEventTypes.map((eventType) => (
        <option key={eventType} value={eventType}>
          {eventType}
        </option>
      ))}
    </TextField>
  );
} 